<template>

  <div class="search">

    <div class="search-line" style="width: auto;">
      <!-- <p  class="search-title" @click="searchShow = !searchShow" >  <i class="el-icon-arrow-right icon-pro" :class="{isActive:searchShow}" ></i> {{$t('message.placeholder.select')}}:</p> -->
      <el-select v-model="baseSelect" :placeholder="$t('message.placeholder.select')" @change="getBaseId" size="small"
        class="search-input">
        <el-option v-for="item in baseInfo" :key="item.value" :label="item.label" :value="item.value">
        </el-option>
      </el-select>
      <!-- <el-select v-model="classIdSelect" :placeholder="$t('message.placeholder.select')" @change="getClassId" size="small" clearable class="search-input"> -->
      <el-select v-model="classIdSelect" :placeholder="$t('message.placeholder.select')" @change="getClassId"
        size="small" clearable class="search-input" style="margin-left: 5px;"> <el-option v-for="item in classIdInfo"
          :key="item.value" :label="item.label" :value="item.value">
        </el-option>
      </el-select>
      <!-- <el-select v-model="subClassIdSelect" @change="getSubClassId" :placeholder="$t('message.placeholder.select')" size="small" clearable style="margin-left: 20px; width: 22%"> -->
      <el-select v-model="subClassIdSelect" @change="getSubClassId" :placeholder="$t('message.placeholder.select')"
        size="small" clearable style="margin-left: 5px; width: 28%"> <el-option v-for="item in subClassIdInfo"
          :key="item.value" :label="item.label" :value="item.value">
        </el-option>
      </el-select>
      <el-button size="small" clearable type="primary" :disabled='nonData' style="margin-left: 20px"
        @click="searchData">
        <i class="el-icon-search"><span style="margin-left: 5px">{{ $t('message.button.search') }}</span></i>
      </el-button>
      <el-button size="small" clearable type="primary" v-show="pageSeekId" :disabled='nonData' @click="saveSearch">
        <i class="el-icon-document-checked"><span style="margin-left: 5px">{{ $t('message.button.save') }}</span></i>
      </el-button>

      <el-button size="small" clearable type="primary" :disabled='nonData' @click="saveSearchShow = true">
        <i class="el-icon-document-checked"><span style="margin-left: 5px">{{ $t('message.button.add') }}</span></i>
      </el-button>

      <slot></slot>
    </div>

    <el-collapse-transition>
      <div v-show="searchShow">
        <div v-for="(item, index) in searchList" :key="index">
          <search-item :getAttr="pageInfo" :change.sync="item.val" :criteriaInfo="item" :loadedSearch="loadedSearch"
            style="width: auto;">
            <el-radio v-model="openParen" :label="index + 1" slot="openParen" style="margin: 0 5px">(</el-radio>
            <el-radio v-model="closeParen" :label="index + 1" slot="closeParen" style="margin: 0 10px">)</el-radio>
          </search-item>
        </div>
      </div>
    </el-collapse-transition>
    <p class="search-title" @click="searchShow = !searchShow">
      <i class="el-icon-arrow-down icon-pro" :class="{ isActive: searchShow }" />
    </p>
    <el-dialog :close-on-click-modal="false" title="保存" v-if="saveSearchShow" :visible.sync="saveSearchShow">
      <SaveSearchForm @submit="subSaveData" @cancel="saveSearchShow = false" />
    </el-dialog>
  </div>

</template>

<script>
import axios from "axios";
import SearchItem from "./searchItem.vue";
import SaveSearchForm from "../saveSearchForm.vue";

export default {
  data() {
    return {
      criteriaName: "",
      criteriaDes: "",
      activeNames: ['1'],
      searchShow: true,

      loadedSearch: false, //如果从个人搜索中加载，为true

      searchList: [],
      nonData: true,
      pageSeekId: false,

      baseInfo: [],
      baseSelect: "",

      classIdInfo: [],
      classIdSelect: "",

      subClassIdInfo: [],
      subClassIdSelect: "",

      pageInfo: [],

      openParen: "",
      closeParen: "",
      subData: [],

      page: 1,
      size: 100,
      saveSearchShow: false
    };
  },
  components: {
    SearchItem,
    SaveSearchForm,
  },
  computed: {


  },
  methods: {

    subSaveData(e) {
      let obj = this.getSearchInfo();
      obj.seekVo.name = e.name;
      obj.seekVo.isPublic = e.type;
      obj.folderId = e.folderId
      //     console.log(e);(obj);
      axios.post("/search/advanced/saveSeek", obj).then((res) => {
        if (res.data.code == 200) {
          this.$message.success(res.data.message);
          this.saveSearchShow = false;
          this.$store.commit('saveSearch');
          this.$store.commit("getReloadTree");
          this.$parent.$emit('reloadFolder')
        }
      });
    },
    handleChange(val) {
      //     console.log(e);(val);
      //     console.log(e);(this.activeNames);
    },
    deleteSearch() {
      //     console.log(e);(this.loadedSearch);
      if (!this.loadedSearch) return true;
      this.$confirm(
        this.$t("message.confirm.deleteSearch"),
        this.$t("message.tips.tip"),
        {
          confirmButtonText: this.$t("message.button.affirm"),
          cancelButtonText: this.$t("message.button.cancel"),
          type: "warning",
        }
      )
        .then(() => {
          let id = this.$route.query.seekId;
          //     console.log(e);(id);
          var vm = this;
          axios
            .post("/pmdm/admin/criteria/deleteSeekById?seekId=" + id)
            .then(function (res) {
              if (res.data.code == 200) {
                //     console.log(e);(res);
                vm.$message({
                  type: "success",
                  message: res.data.message,
                });
                vm.$parent.$emit("deletePage", true);
                vm.$store.commit('saveSearch')
              }
            })
            .catch(function (error) {
              ////     console.log(e);(error);
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: this.$t("message.tips.deleteCancel"),
          });
        });
    },
    reset() {
      this.criteriaName = "";
      this.criteriaDes = "";
      // this.baseInfo = [],
      this.baseSelect = "";
      (this.classIdInfo = []), (this.classIdSelect = "");
      (this.subClassIdInfo = []), (this.subClassIdSelect = "");
      this.searchList = [];
      this.$nextTick(() => {
        this.searchList = Array(3).fill("_").map(i => ({ val: "" }))
        // this.searchList.push({ val: "" });
        // this.searchList.push({ val: "" });
        // this.searchList.push({ val: "" });
      });

      this.openParen = "";
      this.closeParen = "";
    },
    saveASNew() {

    },
    saveSearch() {
      if (
        this.$route.query.seekId != undefined &&
        this.objType == "advancedSearch"
      ) {
        let id = this.$route.query.seekId;
        let obj = this.getSearchInfo();
        obj.seekVo.id = id;
        obj.seekVo.name = this.searchName || this.$route.query.seekName;
        obj.seekVo.isPublic = 0;
        axios.post("/search/advanced/saveSeek", obj).then((res) => {
          if (res.data.code == 200) {
            this.$message.success(res.data.message);
            this.$parent.$emit("deletePage");
            this.$store.commit('saveSearch')
          }
        });
      } else {
        this.$prompt(
          this.$t("message.tips.name"),
          this.$t("message.tips.tip"),
          {
            confirmButtonText: this.$t("message.button.affirm"),
            cancelButtonText: this.$t("message.button.cancel"),
            type: "warning",
          }
        )
          .then((e) => {
            //     console.log(e);(e);

            this.$store.commit("setPersonalSearch", {
              id: 0,
              name: e.value,
              type: 0,
            });
            if (!e.value) {
              this.$message.error(this.$t('message.error.name'))
              return
            }
            var ifExistingInPersonalSearch =
              this.$store.getters.ifExistingInPersonalSearch;
            //     console.log(e);(ifExistingInPersonalSearch);
            if (ifExistingInPersonalSearch === 1) {
              //     console.log(e);(ifExistingInPersonalSearch);
              this.$message({
                message: this.$t("message.warning.alreadyInPersonalSearch"),
                type: "error",
              });
              return;
            }

            let obj = this.getSearchInfo();
            obj.seekVo.name = e.value;
            obj.seekVo.isPublic = 0;
            //     console.log(e);(obj);
            axios.post("/search/advanced/saveSeek", obj).then((res) => {
              if (res.data.code == 200) {
                this.$message.success(res.data.message);
                // this.$parent.$emit("deletePage");
                vm.$store.commit('saveSearch')
                this.$store.commit('getReloadTree')
              }
            });
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: this.$t("message.tips.saveCancel"),
            });
          });
      }
    },
    saveCriteria() {
      this.criteriaName = this.criteriaName.trim();
      if (!this.criteriaName || this.criteriaName.match(/^[ ]*$/)) {
        this.$message.error(this.$t("message.error.name"));
        return false;
      }
      let obj = this.getSearchInfo();
      //     console.log(e);(obj);
      obj.seekVo.name = this.criteriaName;
      obj.seekVo.description = this.criteriaDes;
      obj.seekVo.isPublic = 8;
      if (this.criteriaId != "") {
        obj.seekVo.id = this.criteriaId;
      }
      //     console.log(e);(obj);
      //     console.log(e);(this.criteriaId);
      if (obj.seekVo.baseId == "") {
        this.$message.error(this.$t("message.error.pickBaseClass"));
        return false;
      }
      axios.post("/search/advanced/saveSeek", obj).then((res) => {
        if (res.data.code == 200) {
          this.$message.success(res.data.message);
          this.$emit("changeCriteria");
          // this.$parent.$emit('deletePage')
        }
      });
    },
    getSearchInfo() {
      let arr = [
        { leftParen: 0, rightParen: 0 },
        { leftParen: 0, rightParen: 0 },
        { leftParen: 0, rightParen: 0 },
      ];

      // console.log(this.searchList);
      // console.log(this.searchList.length);
      if (this.searchList[1].val != "" && this.searchList[2].val != "") {
        let l = this.openParen - 1, r = this.closeParen - 1;
        if (l < r) {
          arr[this.openParen - 1].leftParen = 1;
          arr[this.closeParen - 1].rightParen = 1;
        }
      }
      console.log(this.searchList);

      for (let i = 0; i < this.searchList.length; i++) {
        const e = this.searchList[i];
        const { val = '', attrId, relationalOp, logicalOp, value, secValue } = e;
        // // // console.log(e,e.val,arr[i]);
        // // console.log(e.val);
        // if (!e.val) {
        //   e.val = ''
        // }

        if (e.id && !e.val) {
          e.val = { attrId, relationalOp, logicalOp, value, secValue, ...arr[i] }
        }
        if (e.val) {
          e.val = { ...e.val, ...arr[i] }
        }
        // Object.assign(e.val, arr[i]);
      }
      //     console.log(e);(this.searchList);
      let a = this.searchList.map((i) => {
        return i.val;
      });
      console.log(a);
      for (let i = 0; i < a.length; i++) {
        if (a[i].relationalOp == "") {
          a[i] = "";
        }
      }
      //     console.log(e);(a);
      let newArr = [];
      for (let i = 0; i < a.length; i++) {
        const e = a[i];
        if (e !== "") {
          newArr.push(e);
        }
      }
      let seekVo = {};
      seekVo.baseId = this.baseSelect;
      seekVo.clsId = this.classIdSelect;
      seekVo.subId = this.subClassIdSelect;
      let obj = {};
      obj.seekVo = seekVo;
      obj.criteriaVos = newArr;
      console.log(newArr, this.searchList);

      obj.pageSize = this.size;
      obj.currentPage = this.page;
      // this.searchObj = obj;
      return obj;
    },

    searchData() {
      let obj = this.getSearchInfo();
      obj.currentPage = 1;
      this.$emit('change', obj)
      // this.searchShow = true;
      // axios.post("/search/advanced/search", obj).then((res) => {
      //   if (res.data.code == 200) {
      //     this.activeNames = [];
      //     this.$emit("change", { data: res.data, searchInfo: obj });
      //   } else {
      //     this.$message.error(res.data.message);
      //   }
      // });
    },

    getPageData(e) {
      this.subData = e;
    },
    getBaseId(e) {
      //     console.log(e);(e);
      this.classIdSelect = "";
      this.subClassIdSelect = "";
      let m = this.baseInfo.find(i => i.value == e);
      this.classIdInfo = m.children;
      this.$emit('getBaseId', m)
      this.getSearchContent();
    },
    getClassId(e) {
      //     console.log(e);(e);
      this.subClassIdSelect = "";
      this.subClassIdInfo = [];
      if (e) {
        this.subClassIdInfo = this.classIdInfo.find(i => i.value == e).children;
      }
      this.getSearchContent();
    },
    getSubClassId(e) {
      this.getSearchContent();
    },

    getData() {
      //     console.log(e);(this.$route.query.seekId);
      //     console.log(e);(this.objType);
      //     console.log(e);(this.criteriaId);
      if (
        (this.$route.query.seekId != undefined &&
          this.objType == "advancedSearch") ||
        (this.criteriaId != undefined &&
          this.criteriaId != "" &&
          this.objType == "criteria")
      ) {
        let id = 0;

        if (
          this.$route.query.seekId != undefined &&
          this.objType == "advancedSearch"
        ) {
          id = this.$route.query.seekId;
        }

        if (
          this.criteriaId != undefined &&
          this.criteriaId != "" &&
          this.objType == "criteria"
        ) {
          id = this.criteriaId;
        }

        this.combineSearchCriteria(id);
      } else {
        axios.get("/search/advanced/getClsListForSearch?adminConfig=1").then((res) => {
          //     console.log(e);(res);
          const classList = res.data.object.clsList;
          this.baseInfo = [...classList]
          const seekId = this.$route.query.seekId;
          const { classId } = this.$store.state.objectId;
          console.log({ seekId, classId });
          if (seekId == 10301) {
            // this.baseInfo = classList.filter(i =>i.value !=106 && i.value != 301)
            this.baseInfo = classList.filter(i => [101, 104, 105].includes(i.value))
            //     console.log(e);(this.baseInfo);
          }
          // if (seekId == 10303 ||seekId == 10302 ||seekId == 10603 || this.creatBy == 'BOM' || this.creatBy == 'affectedItem'){
          if ([10303, 10302, 10603].includes(seekId) || ['BOM', 'affectedItem'].includes(this.creatBy)) {
            this.baseInfo = classList.filter(i => i.value == 101)
          }
          if (classId == 10410) {
            this.baseInfo = classList.filter(i => i.value == 501)
          }
          if (seekId == 10304 || this.creatBy == 'project') {
            this.baseInfo = classList.filter(i => i.value == 301)
          }
          // console.log(e);(this.baseInfo);
          if (this.baseInfo.length != 0) {
            this.nonData = false;
            this.baseSelect = this.baseInfo[0].value;
            this.classIdInfo = this.baseInfo.find(i => i.value == this.baseSelect).children;
            this.getSearchContent();
          }
        });
      }
    },

    combineSearchCriteria(id) {
      this.searchList = [];
      this.loadedSearch = true;
      this.$http.get("/search/advanced/getSeekInfo?seekId=" + id).then((res) => {
        this.criteriaName = res.data.object.seek.name;
        this.criteriaDes = res.data.object.seek.description;
        this.baseSelect = res.data.object.seek.baseId;
        this.classIdSelect = res.data.object.seek.clsId;
        this.subClassIdSelect = res.data.object.seek.subId;
        this.baseInfo = res.data.object.clsList;
        this.classIdInfo = this.baseInfo.find(i => i.value == this.baseSelect).children;
        if (this.classIdSelect != null) {
          this.subClassIdInfo = this.classIdInfo.find(i => i.value == this.classIdSelect).children;
        }
        this.nonData = false;
        this.getSearchContent();
        this.searchList = res.data.object.criteriaList;
        let arr = new Array(3 - this.searchList.length).fill("_").map(i => ({ val: '' }));
        this.searchList = [...this.searchList, ...arr];
        this.searchData();
        for (let i = 0; i < this.searchList.length; i++) {
          const e = this.searchList[i];
          if (this.searchList[i].leftParen == 1) this.openParen = i + 1;
          if (this.searchList[i].rightParen == 1) this.closeParen = i + 1;
        }
      });
    },
    getSearchContent() {
      let obj = {
        baseId: this.baseSelect,
        classId: this.classIdSelect,
        subClassId: this.subClassIdSelect,
      };
      this.searchList = new Array(3).fill("_").map(i => ({ val: "" }))
      // this.searchList = [{ val: "" }, { val: "" }, { val: "" }];
      //     console.log(e);(this.searchList);
      this.pageInfo = [];
      axios
        .get(`/search/advanced/getAttrListForSearch${this.params(obj)}`)
        .then((res) => {
          // //     console.log(e);(res.data.object);
          if (res.data.code == 200) {
            let arr = Object.values(res.data.object);
            // //     console.log(e);(arr);
            let n = {};
            let attrList = Object.keys(arr[0]);
            for (let i = 0; i < attrList.length; i++) {
              const e = attrList[i];
              n[e] = [];
              // //     console.log(e);(e);
              for (let j = 0; j < arr.length; j++) {
                const ele = arr[j];
                // //     console.log(e);(ele);
                n[e] = n[e].concat(ele[e]);
              }
            }
            // //     console.log(e);(n);

            let m = n.ids.map((i, e) => {
              return {
                value: i,
                label: n.names[e],
                uiType: n.uiTypes[e],
                listId: n.listIds[e],
                listType: n.listTypes[e]
              };
            });
            let idList = {
              baseId: this.baseSelect,
              classId: this.classIdSelect,
              subClassId: this.subClassIdSelect,
            };
            this.pageInfo = [n, m, idList];
          } else {
            this.$message.error(res.data.message);
          }
        });
    },
  },
  props: ["pageSize", "currentPage", "objType", "criteriaId", "searchName", 'creatBy', 'messageData'],
  watch: {
    pageSize(e) {
      this.size = e;
      this.searchData();
    },
    currentPage(e) {
      this.page = e;
      this.searchData();
    },
    searchName(e) {
      //     console.log(e);(this.searchName);
    },
  },
  created() {
    //     console.log(e);(this.objType);
    //     console.log(e);(this.criteriaId);
    // this.input_width = this.Global.input_width;
    if (this.messageData == "NO" || this.messageData == undefined) {
      this.getData();
    }
    const { seekId } = this.$route.query
    this.pageSeekId = !!Number(seekId);
    // this.getSearchContent();
  },
};
</script>

<style>
/* .create-list-subClass .el-upload{
  display: block ;
} */
/* .search .el-collapse-item__header {
  height: 30px;
} */
.search-table .el-collapse {
  border-top: none !important;
}

.search-table .el-collapse-item__arrow {
  /* font-size: 20px; */
  text-align: center;
  /* color: #3ea0fb; */
  /* margin: auto; */
  margin-left: -15px;
  font-weight: 600;
}

.search-table .el-collapse-item__wrap {
  border-bottom: none;
}
</style>
<style scoped>
.icon-pro {
  transition: -webkit-transform .3s;
  -webkit-transition: -webkit-transform .3s;
  transition: transform .3s;
  transition: transform .3s, -webkit-transform .3s;
  transition: transform .3s, -webkit-transform .3s;
}

.icon-pro.isActive {
  /* -webkit-transform: rotate(90deg);
  transform: rotate(90deg); */
  -webkit-transform: rotate(180deg);
  transform: rotate(180deg);
}

.search-title {
  display: inline-block;
  cursor: pointer;
  text-align: center;
  padding-top: 8px;
  width: 100%;
  /* margin-left: 44%;
  margin-bottom: 0;
  margin-top: 0; */
  transition: 0.4s;
}

.search-title:hover {
  color: #409EFF;
}

.search-input {
  /* margin-left: 15px; */
  margin-left: 43px;
  width: 15%;
}

.search-line {
  margin: 5px 0 0 10px;
  width: 1200px;
  overflow: hidden;
}

.search {
  width: 100%;
  height: 100%;
  background: #fff;
  /* margin: 5px; */
}
</style>
